import { render, staticRenderFns } from "./TrackingList.vue?vue&type=template&id=2facc8c6"
import script from "./TrackingList.vue?vue&type=script&lang=js"
export * from "./TrackingList.vue?vue&type=script&lang=js"
import style0 from "./TrackingList.vue?vue&type=style&index=0&id=2facc8c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports